import { HostedFieldFieldOptions } from 'braintree-web';

type HostedFieldKeyType = keyof HostedFieldFieldOptions;

export const HostedFieldKeys: readonly HostedFieldKeyType[] = [
    'cardholderName',
    'number',
    'expirationDate',
    'cvv',
    'postalCode',
] as const;
